var PILL_CLASSES = {
  base: "bg-sds-base-secondary text-sds-base-secondary border-sds-base-secondary",
  brand: "bg-sds-brand-tertiary text-sds-brand-default border-sds-brand-secondary",
  success: "bg-sds-success-tertiary text-sds-success-secondary border-sds-success-secondary",
  attention: "bg-sds-attention-tertiary text-sds-attention-secondary border-sds-attention-secondary",
  urgent: "bg-sds-urgent-tertiary text-sds-urgent-secondary border-sds-urgent-secondary"
};

/** Returns the pill colour classes for a semantic intent. */
export function statusPillClasses(intent) {
  return PILL_CLASSES[intent];
}